import {Logger} from "@nice-ccf/core-sdk";
import {AgentLog, ContactLog, SkillLog} from "@nice-ccf/common-sdk";
/**
 * Wrapper for Logger component
 */
export class CcfLogger {
  private logger!: Logger;

  /**
   * Get the module name and class name while create logger object
   *
   * @param module - Module name as an optional
   * @param className - Class name as an optional
   * @example
   * ```
   * const logger = new Logger('module name', class name');
   * ```
   */
  constructor(private module?: string, private className?: string) {
    this.logger = new Logger(module, className);
  }

  /**
   *
   * @param functionName - Log function message
   * @param message - Log message
   * @param data - Log data object
   * @example
   * ```
   * console.error('log error');
   * ```
   */
  error(functionName: string, message: string,  data?: ContactLog | AgentLog | SkillLog) {
    this.logger.error(functionName, message, data);
  }

  /**
   *
   * @param functionName - Log function message
   * @param message - Log message
   * @param data - Log data object
   * @example
   * ```
   * console.info('log info');
   * ```
   */
  public info(functionName: string, message: string,  data?: ContactLog | AgentLog | SkillLog) {

    this.logger.info(functionName, message, data);
  }

  /**
   *
   * @param functionName - Log function message
   * @param message - Log message
   * @param data - Log data object
   * @example
   * ```
   * console.trace('log info');
   * ```
   */
  public trace(functionName: string, message: string,  data?: ContactLog | AgentLog | SkillLog) {
    this.logger.trace(functionName, message, data);
  }
}
